import COLORS from '../../../utils/constants/colors'
import { CARD_STYLES } from '../../../utils/constants/CSS/cardStyles'

// Below these widths the duties, then the access, wrap under the person's name.
const DUTIES_WRAP = '@media (max-width: 1279px)'
const ACCESS_WRAP = '@media (max-width: 599px)'

const orgUsersPageStyles = {
  card: CARD_STYLES.card,
  cardTitle: CARD_STYLES.cardTitle,
  cardSubtitle: {
    ...CARD_STYLES.cardSubtitle,
  },
  loaderIcon: {
    fill: COLORS.orange,
    marginRight: '48%',
    marginLeft: '48%',
    marginTop: 20,
    width: 70,
    height: 70,
  },
  addButtonWrapper: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: 15,
    gap: 15
  },
  // Users table (Claude Design "Organisation Users — roles").
  usersCard: {
    padding: '28px 32px 16px',
    [ACCESS_WRAP]: { padding: '20px 16px 12px' },
  },
  // One row per person, and the heading above them.
  grid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 440px) 120px minmax(0, 1fr) 44px',
    gridTemplateAreas: '"member access duties action"',
    columnGap: 24,
    rowGap: 10,
    alignItems: 'center',
    [DUTIES_WRAP]: {
      gridTemplateColumns: 'minmax(0, 1fr) 120px 44px',
      gridTemplateAreas: '"member access action" "duties duties duties"',
    },
    [ACCESS_WRAP]: {
      gridTemplateColumns: 'minmax(0, 1fr) 44px',
      gridTemplateAreas: '"member action" "access access" "duties duties"',
    },
  },
  memberCell: { gridArea: 'member' },
  accessCell: {
    gridArea: 'access',
    // Under the name, past the 40px avatar and its 14px gap.
    [ACCESS_WRAP]: { paddingLeft: 54 },
  },
  dutiesCell: {
    gridArea: 'duties',
    [DUTIES_WRAP]: { paddingLeft: 54 },
  },
  actionCell: { gridArea: 'action' },
  // The remove confirmation takes the duties and action columns, or the duties line once wrapped.
  confirmCell: {
    gridColumn: 'duties-start / action-end',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 12,
    minWidth: 0,
    [DUTIES_WRAP]: { gridArea: 'duties', paddingLeft: 54, justifyContent: 'flex-start', flexWrap: 'wrap' },
  },
  headerRow: {
    // Once the duties wrap under each name there is no column left for their heading.
    [DUTIES_WRAP]: { '& $dutiesCell': { display: 'none' } },
    [ACCESS_WRAP]: { '& $accessCell': { display: 'none' } },
  },
  row: {
    '&:hover': { background: '#fafafa' },
  },
  chip: {
    '&:hover:not(:disabled)': { borderColor: '#bdbdbd' },
    '&:disabled': { cursor: 'default' },
  },
  iconButton: {
    '&:hover:not(:disabled)': { background: '#f0f0f0' },
  },
  removeButton: {
    color: '#8a8a8a',
    '&:hover:not(:disabled)': { color: '#c4453f' },
  },
  inviteButton: {
    '&:hover': { background: '#b23a35' },
  },
  deleteButton: {
    '&:hover:not(:disabled)': { background: '#b23a35' },
  },
  search: {
    '&:focus-within': { borderColor: '#c9453f', boxShadow: '0 0 0 3px #fbe3e2' },
    '& input': { outline: 'none' },
  },
  select: {
    '&:focus': { outline: '2px solid #c9453f', outlineOffset: 1 },
  },
  // The native arrow's position differs per browser; a drawn chevron keeps it 10px from the
  // right edge, matching the text's left padding.
  accessSelect: {
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23616161' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 10px center',
  },
}
export default orgUsersPageStyles
